export default "__VITE_ASSET__ZsV9vYD7__"